module.exports = __webpack_public_path__ + "62cfff86c2516a58f2ae324353525fa2.svg";